export function setLocalStorageItem(storageKey: string, name: string, value: any) {
    try {
        const params = JSON.parse(localStorage.getItem(storageKey) || '{}');
        params[name] = value;
        localStorage.setItem(storageKey, JSON.stringify(params));
    } catch (e) {
        localStorage.setItem(storageKey, JSON.stringify({
            [name]: value,
        }));
    }
}
